var editor = {
    activeLayerID:null,
    baseLayerID:null,
    connectionsLayerID:null,
    accesoriesLayerID:null,
    appendCursor:false,
    ctrlDown: false,
    connectionLayers: [],

    /**
     * A kiválasztott elem id-jának a sorszáma, tehát nem "element_165" hanem 165
     */
    _selectedElementID: null,



    appendedObject: {
        templateObjectID: null,
        templateObjectName: null,
        appended: false,
        update: function(templateObjectID){
            this.templateObjectID = templateObjectID;

            if((this.templateObjectID == templateObjectID && this.appended == false) || this.templateObjectID != templateObjectID){
                this.appended = true;
            } else {
                this.appended = false;
            }
        }
    },

    selectObject: function(btnObj){
        $('#dropdownFastButton span').text($(btnObj).data('name'));
        $('#dropdownFastButton').data('id', $(btnObj).data('id'));

        editor.appendObject($(btnObj).data('id'), true);
    },
    appendObject: function(templateObjectID, fromList)
    {
        if(editor.appendedObject.appended == false){
            editor.appendedObject.update(templateObjectID);

            fromList = fromList || false;
            editor.appendCursor = true;

            if(fromList) {
                $('#dropdownButton').removeClass('open');
                $('.dropdown-backdrop').remove()
            }

            $('#gridbox').css('cursor', 'crosshair');

            $('#gridbox').bind('click', function(event) {
                $('#gridbox').unbind('click');
                $('#gridbox').css('cursor', 'default');

                editor.createObject(templateObjectID, editor.fromRelative(editor.posX(event.pageX)), editor.fromRelative(editor.posY(event.pageY)));

                editor.cursorDefaultBind();
                editor.appendCursor = false;
                editor.appendedObject.appended = false;
            });
        }
    },
    cursorDefaultBind: function(){
        $('#gridbox').bind('click', function(e){
            if(!$(e.target).hasClass('element')){
                editor.displayDataClean();
                editor.unselected();
            }
        });
    },
    createObject: function(templateObjectID, centerx, centery)
    {
        $.post('/stages/editor/createObject/' + templateObjectID, {centerx: centerx, centery: centery}, function(resp){
            if(resp != 'undefined'){
                editor.refreshListElement(resp.layerID, resp.listElement);
                editor.loadElements(resp);

                if(editor.visibleLayer(resp.layerID)){
                    editor.selectElement(SVG.get('element_' + resp.objectID));
                }
            }
        }, 'json');
    },

    refreshListElement: function(layerID, listElement){
        var elementListBody = $('#layer_' + layerID).find('.elementList tbody');

        $(elementListBody).append(listElement);
        editor.refreshListElementBadge(layerID);
    },
    refreshListElementBadge: function(layerID){
        $('#layer_' + layerID).find('.badge').html($('#layer_' + layerID).find('.elementList tbody').find('tr').length);
    },

    selectElement: function(element)
    {
        $.each(SVG.select('g:not(#'+element.attr('id')+'_group) .selected').members, function () {
            SVG.get(this.node.id).remove();
        });

        if(element.data('layerid') == editor.activeLayerID) {
            editor.unselected();
            editor.displayDataClean();
            editor._selectedElementID = element.data('id');


            element.addClass('ui-selected');
            var $this = SVG.get(element.attr('id'));

            if($this.parent().select('rect:not(#'+element.attr('id')+')').members.length == 0) {
                editor.addSelectRect($this);
            }

            editor.displayDataV2();

            var elementListPanel = $('#layer_' + $(element).data('layerid') + ' .elementListPanel');

            elementListPanel.animate({
                scrollTop: (elementListPanel.scrollTop() + $('#element_list_' + element.data('id')).position().top
                - elementListPanel.height() / 2 + $('#element_list_' + element.data('id')).height() / 2) + 'px'
            }, 'fast');
        }
    },

    unselected: function(){
        $('.selected').remove();
        $('.ui-selected').removeClass('ui-selected');
        $('#elementList tr').removeClass('ui-selected');

        editor._selectedElementID = null;
    },

    isSelectedElement: function(){
        var element = SVG.get($('.element.ui-selected').attr('id') || '');

        if(element !== null){
            return element;
        } else {
            return false;
        }
    },

    /**
     * Visszaadja a kiválasztott elem id-jának sorszámát, tehát nem "element_165"-öt, hanem csak "165"-öt, ha nincs kiválasztva semmi, akkor null értékkel tér vissza.
     * @returns null||int
     */
    selectedElementID: function(){
        var elementID = $('.element.ui-selected').data('id');

        if(elementID == undefined || elementID == null || elementID == '' || parseInt(elementID) == 0) {
            return null;
        } else {
            return parseInt(elementID);
        }
    },


    addSelectRect: function (element) {
        var rect = element.parent()
            .rect(element.width()+1, element.height()+1)
            .move(element.x()-1, element.y()-1)
            .attr({
                'stroke': '#fff',
                'stroke-width': 1,
                'fill': 'transparent',
                'stroke-dasharray':'5, 5',
            }).addClass('selected').back();
        console.log(rect);
        if(parseInt(element.data('rotation')) > 0){
            rect.attr('transform',element.matrixify().toString());
        }
    },
    addSelectRectV2: function () {
        var element = SVG.get('element_' + editor._selectedElementID),
            rect = element.parent()
            .rect(element.width()+1, element.height()+1)
            .move(element.x()-1, element.y()-1)
            .attr({
                'stroke': '#fff',
                'stroke-width': 1,
                'fill': 'transparent',
                'stroke-dasharray':'5, 5',
            }).addClass('selected').back();

        if(parseInt(element.data('rotation')) > 0){
            rect.attr('transform',element.matrixify().toString());
        }
    },
    removeSelectRect: function(){
        $('#element_' + editor._selectedElementID).parent().find('rect').remove();
    },

    /*displayData: function(element){
        element = element || false;

        if(element){
            var el = element,
                rotation = (el.data('rotation') === undefined || el.data('rotation') == '') ? 0 : el.data('rotation');

            rotation = ($('#displaydata #rotation').val() == '' ? rotation : $('#displaydata #rotation').val());

            var x = el.rbox().x + $("#gridbox").parent().scrollLeft(),
                y = ($("#gridsvg").height()) - (el.rbox().y) - ($("#gridbox").parent().scrollTop());

            $("#displaydata #x").val(parseInt(editor.pixelTo(x)));
            $("#displaydata #x").attr('data-centerx',editor.pixelTo(x));
            $("#displaydata #centery").val(parseInt(editor.pixelTo(y)));
            $("#displaydata #centery").attr('data-centery',editor.pixelTo(y));

            if(el.data('resize') > 0){
                $('#displaydata #width').attr('disabled', null);
                $("#displaydata #width").val(parseInt( editor.pixelTo(el.bbox().w)));
                $("#displaydata #width").attr('data-width', editor.pixelTo(el.bbox().w));
            } else {
                $('#displaydata #width').attr('disabled', 'disabled');
                $("#displaydata #width").val(parseInt( editor.pixelTo(el.bbox().w)));
                $("#displaydata #width").attr('data-width', editor.pixelTo(el.bbox().w));
            }

            if(el.data('resize') > 0){
                $('#displaydata #height').attr('disabled', null);
                $("#displaydata #height").val(parseInt( editor.pixelTo(el.bbox().h)));
                $("#displaydata #height").attr('data-height', editor.pixelTo(el.bbox().h));
            } else {
                $('#displaydata #height').attr('disabled', 'disabled');
                $("#displaydata #height").val(parseInt( editor.pixelTo(el.bbox().h)));
                $("#displaydata #height").attr('data-height', editor.pixelTo(el.bbox().h));
            }

            $("#displaydata #rotation").val(rotation);
        }
    },*/
    /**
     * Visszatér egy objektummal, amely azokat az értékeket tartalmazza, amelyeket a displaydata-ra írnánk mm-ben átváltva.
     * @returns {{x: number, y: number, rotation: *, width: number, height: number, resize: number}}
     */
    displayDataParams: function(){
        var jqObj = $('#element_' + editor._selectedElementID),
            svgObj = SVG.get('element_' + editor._selectedElementID + '_group');

        return {
            x: Math.round(editor.pixelToMM( svgObj.rbox().x + $("#gridbox").parent().scrollLeft() )),
            y: Math.round(editor.pixelToMM( $("#gridsvg").height() - svgObj.rbox().y2 - $("#gridbox").parent().scrollTop() )),
            rotation: (jqObj.data('rotation') === undefined || jqObj.data('rotation') == '') ? 0 : jqObj.data('rotation'),
            width: Math.round( editor.pixelToMM(jqObj.data('width')) ),
            height: Math.round( editor.pixelToMM(jqObj.data('height')) ),
            resize: jqObj.data('resize')
        };
    },
    displayDataV2: function()
    {
        if(editor._selectedElementID !== null)
        {
            editor.removeSelectRect();
            var params = editor.displayDataParams();
            editor.addSelectRectV2();

            $("#displaydata #rotation").val(params.rotation);
            $("#displaydata #x").val(params.x);
            $("#displaydata #y").val(params.y);

            if(params.resize > 0){
                $('#displaydata #width').attr('disabled', null);
                $("#displaydata #width").val(params.width);

                $('#displaydata #height').attr('disabled', null);
                $("#displaydata #height").val(params.height);
            } else {
                $('#displaydata #width').attr('disabled', 'disabled');
                $("#displaydata #width").val(params.width);

                $('#displaydata #height').attr('disabled', 'disabled');
                $("#displaydata #height").val(params.height);
            }
        }
    },
    displayDataClean: function(){
        $('#displaydata input').each(function(id, obj){
            $(obj).val('');
        });
    },
    removeElement: function(element)
    {
        popup("Are you sure you want to remove this element?").confirm(true, function (result) {
            if(result) {
                var elementID = element.data('id');

                $.post('/stages/editor/deleteObject/' + elementID, {}, function (resp) {
                    $("#element_list_" + elementID).remove();
                    editor.refreshListElementBadge(element.data('layerid'));
                    element.parent().remove();
                    $(".selected").remove();
                    $('.connection-arrow[data-to="' + element.data('id') + '"], .connection-arrow[data-from="' + element.data('id') + '"]').remove();

                    notify.add('Notice', 'Element removed!', {noteStyle: 'danger'});
                });
            }else{
                // laddaInstance.stop();
            }
        });
    },
    removeElementV2: function()
    {
        popup("Are you sure you want to remove this element?").confirm(true, function (result) {
            if(result)
            {
                $.post('/stages/editor/deleteObject/' + editor._selectedElementID, {}, function (resp) {
                    var selectedElement = SVG.get('element_' + editor._selectedElementID);

                    $("#element_list_" + editor._selectedElementID).remove();
                    editor.refreshListElementBadge(selectedElement.data('layerid'));
                    selectedElement.parent().remove();
                    $(".selected").remove();
                    $('.connection-arrow[data-to="' + editor._selectedElementID + '"], .connection-arrow[data-from="' + editor._selectedElementID + '"]').remove();

                    notify.add('Notice', 'Element removed!', {noteStyle: 'danger'});
                });
            }
        });
    },
    posX: function(x_pixel){
        return parseInt(x_pixel - $('#gridbox').offset().left);
    },
    posY: function(y_pixel){
        return parseInt(y_pixel - $('#gridbox').offset().top);
    },
    centerPos: function(element){
        var offset = $(element);
        var position = offset.position();
        var width= $(element).width();
        var height = $(element).height();

        return {
            x: (position.left + (width / 2)),
            y: (position.top + (height / 2))
        };
    },

    /**
     * Visszaadja a pixel és mm közti váltószámot, pl 1px az 0.15mm; <b>A zoomolási direktíva nélkül.</b>
     * @returns {number}
     */
    shiftValue: function(){
        return (gridH * 2) / 1000;
    },
    /**
     * A pixelben megadott értéket átlalkítja miliméterbe.
     * @param pixel
     * @returns {number}
     */
    pixelToMM: function(pixel){
        return pixel / (editor.shiftValue() * actZoom);
    },
    /**
     * A mm-ben megadott értéket átalakítja pixelbe.
     * @param mm
     * @returns {number}
     */
    mmToPixel: function(mm){
        return mm * (editor.shiftValue() * actZoom);
    },
    /**
     * A gridben használt mértékegységet visszaváltja az eredeti zoom szerinti értékre.
     * @param value
     * @returns {number}
     */
    fromRelative: function(value){
        return value / actZoom;
    },
    /**
     * Az eredeti értéket átváltja a zoom-nak megfelelő értékbe
     * @param value
     * @returns {number}
     */
    toRelative: function(value){
        return value * actZoom;
    },
    move_z: function(index)
    {                               //$('#element_876_group').append($('#element_844_group').clone())
        var element;

        if((element = editor.isSelectedElement()) !== false)
        {
            var z_index = element.data('z_index');

            if(z_index == '' || z_index == 'undefined'){
                z_index = 1;
            }

            var newIndex = parseInt(z_index) + index;

            if(newIndex < 1){
                newIndex = 1;
            } else if(newIndex > 999){
                newIndex = 999;
            }

            element.data('z_index', newIndex);

            if(index == 1){
                SVG.get('#element_' + element.data('id') + '_group').forward();
            } else {
                SVG.get('#element_' + element.data('id') + '_group').backward();
            }


            editor.modifyElement(element);
        } else {
            popup('Please select element!').alert();
        }
    },
    /*save: function(move){
        move = move || false;
        var element = SVG.get($('.ui-selected').attr('id'));
        element.rotate(0);

        if(typeof element == 'object'){
            $('#displaydata input').each(function(index, obj){
                var val = $(obj).val(),
                    rotation = (element.data('rotation') === undefined || element.data('rotation') == '') ? 0 : element.data('rotation');

                rotation = ($('#displaydata #rotation').val() == '' ? rotation : $('#displaydata #rotation').val());

                if(obj.id == 'centerx'){
                    var positionWidth = (( Math.abs(rotation) < 90 || (Math.abs(rotation) >179 && Math.abs(rotation) <270) ) ? $('#displaydata #width').data('width') : $('#displaydata #height').data('height')) / actZoom;
                    val = editor.mmToPixel(parseFloat($(this).attr('data-centerx'))) / actZoom;
                    val = (val + editor.mmTo(positionWidth) / 2) / r;
                }
                else if(obj.id == 'centery'){
                    var positionHeight = (( Math.abs(rotation) < 90 || (Math.abs(rotation) >179 && Math.abs(rotation) <270) ) ? $('#displaydata #height').data('height') : $('#displaydata #width').data('width')) / actZoom;
                    val = ($("#gridsvg").height() / actZoom - editor.mmToPixel(parseFloat($(this).attr('data-centery')) / actZoom) + editor.mmToPixel(positionHeight / 2)) / r;
                }
                else if(obj.id == 'width'){
                    var positionWidth = $('#displaydata #width').data('width');
                    val = editor.mmToPixel(parseFloat(positionWidth) / r) / actZoom;
                }
                else if(obj.id == 'height'){
                    var positionHeight = $('#displaydata #height').data('height');
                    val = editor.mmToPixel(parseFloat(positionHeight) / r) / actZoom;
                }

                // console.log(obj.id, val);

                element.data(obj.id, val);
            });

            editor.modifyElement(element,move);
        } else {
            popup('Please select element!').alert();
        }
    },*/
    /*modifyElement: function(element, move){
        move = move || false;
        var params = {};
        var elem = element;
        for(var i in $("#"+element.attr('id')).data()){
            if(typeof(elem.data(i)) != 'object' && typeof(elem.data(i)) != 'boolean'){
                eval("params." + i + " = '" + elem.data(i) + "'");
            }
        }

        if(params.id != 'undefined') {
            editor.configureElement(editor.getJSONParams(elem),move);
            // editor.configureElement($(element));

            $('.connection-arrow[data-to="' + elem.data('id') + '"], .connection-arrow[data-from="' + elem.data('id') + '"]').each(function(index, obj){
                var connectionObject = $(obj);
                var from = SVG.get('element_' + connectionObject.data('from'));
                var to = SVG.get('element_' + connectionObject.data('to'));
                var connectionSvg = SVG('gridsvg');

                var modifyedConnectionElement = editor.configureConnection({
                    id: connectionObject.data('id'),
                    from: connectionObject.data('from'),
                    centerx1: from.data('centerx'),
                    centery1: from.data('centery'),
                    width1: from.data('width'),
                    height1: from.data('height'),
                    to: connectionObject.data('to'),
                    centerx2: to.data('centerx'),
                    centery2: to.data('centery'),
                    width2: to.data('width'),
                    height2: to.data('height'),
                    'connectiontype_color': connectionObject.data('connectiontype_color'),
                    'connectiontype_name': connectionObject.data('connectiontype_name'),
                });
                obj.remove();
                // connectionSvg.removeChild(obj);
                connectionSvg.add(modifyedConnectionElement);
                editor.bindConnectionEvents(modifyedConnectionElement);
            });

            $.post('/stages/editor/modifyElement/' + params.id, params, function(resp){});
        }
    },*/
    bindEvents: function(obj)
    {
        obj.off('click');

        obj.draggable(true, {}, function(obj, e){
            var nearestLineH = {},
                nearestLineV = {},
                target = obj.el,
                // nearestXH = 100,
                nearestXV = 100,
                nearestYH = 100;
            // nearestYV = 100;

            // console.log(obj);

            $.each(SVG.select('.verticalGuideLine').members, function(){
                if(Math.abs(target.rbox().x - this.rbox().x) < nearestXV/* && Math.abs(target.rbox().x - this.rbox().x) < nearestYV*/){
                    nearestLineV = this;
                    nearestXV = Math.abs(target.rbox().x - this.rbox().x);
                }else if(Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestXV/* && Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestYV*/){
                    nearestLineV = this;
                    nearestXV = Math.abs(target.rbox().x + target.rbox().w - this.rbox().x);
                }
                // if(Math.abs(target.rbox().y - this.rbox().y) < nearestYV && Math.abs(target.rbox().y - this.rbox().y) < nearestXV){
                //     nearestLineV = this;
                //     nearestYV = Math.abs(target.rbox().y - this.rbox().y);
                // }else if(Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestYV && Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestXV){
                //     nearestLineV = this;
                //     nearestYV = Math.abs(target.rbox().y + target.rbox().h - this.rbox().y);
                // }
            });
            $.each(SVG.select('.horizontalGuideLine').members, function(){
                // if(Math.abs(target.rbox().x - this.rbox().x) < nearestXH && Math.abs(target.rbox().x - this.rbox().x) < nearestYH){
                //     nearestLineH = this;
                //     nearestXH = Math.abs(target.rbox().x - this.rbox().x);
                // }else if(Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestXH && Math.abs(target.rbox().x + target.rbox().w - this.rbox().x) < nearestYH){
                //     nearestLineH = this;
                //     nearestXH = Math.abs(target.rbox().x + target.rbox().w - this.rbox().x);
                // }
                if(Math.abs(target.rbox().y - this.rbox().y) < nearestYH/* && Math.abs(target.rbox().y - this.rbox().y) < nearestXH*/){
                    nearestLineH = this;
                    nearestYH = Math.abs(target.rbox().y - this.rbox().y);
                }else if(Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestYH/* && Math.abs(target.rbox().y + target.rbox().h - this.rbox().y) < nearestXH*/){
                    nearestLineH = this;
                    nearestYH = Math.abs(target.rbox().y + target.rbox().h - this.rbox().y);
                }
            });

            var nearestLine = nearestXV < nearestYH?nearestLineV:nearestLineH,
                closest = editor.closestPoint(nearestLine,[e.pageX || e.changedTouches[0].pageX,e.pageY || e.changedTouches[0].pageY]),
                closestH = editor.closestPoint(nearestLineH,[e.pageX || e.changedTouches[0].pageX,e.pageY || e.changedTouches[0].pageY]),
                closestV = editor.closestPoint(nearestLineV,[e.pageX || e.changedTouches[0].pageX,e.pageY || e.changedTouches[0].pageY]),
                offset = {};

            // console.log(nearestLine == nearestLineH, nearestLine == nearestLineV);

            // console.log((Math.abs(target.rbox().x - closest[0]) < 10 || Math.abs(target.rbox().y - closest[1]) < 10) && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg'));

            if((Math.abs(target.rbox().x - closest[0]) < 10 || Math.abs(target.rbox().y - closest[1]) < 10)/* && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg')*/) {
                if (nearestLine.hasClass('verticalGuideLine')) {
                    offset.left = closest[0];
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.top = closestH[1];
                    // }
                } else {
                    offset.top = closest[1];
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.left = closestV[0];
                    // }
                }
            }

            // console.log((Math.abs(target.rbox().x + target.rbox().w - closest[0]) < 10 || Math.abs(target.rbox().y + target.rbox().h - closest[1]) < 10) && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg'));

            if((Math.abs(target.rbox().x + target.rbox().w - closest[0]) < 10 || Math.abs(target.rbox().y + target.rbox().h - closest[1]) < 10)/* && (e.target.id == obj.el.node.id || e.target.id !== 'gridsvg')*/) {
                if (nearestLine.hasClass('verticalGuideLine')) {
                    offset.left = closest[0] - target.rbox().w;
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.top = closestH[1] - target.rbox().h;
                    // }
                } else {
                    offset.top = closest[1] - target.rbox().h;
                    // if(nearestYH < 10 && nearestXV < 10){
                    //     offset.left = closestV[0] - target.rbox().w;
                    // }
                }
            }

            // return offset;
            return {};
        })
            .on('beforedrag', function (e) {
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }


                var element = SVG.get(e.target.id);
                if (editor.activeLayerID == element.data('layerid')) {
                    editor.selectElement(element);
                    $('.connection-arrow[data-to="' + element.data('id') + '"], .connection-arrow[data-from="' + element.data('id') + '"]').toggle();
                } else {
                    $('#gridTooltip').html("<div class='ui-widget-header'>This element is not included in the active layer!</div>");
                    // obj.draggable(false);
                    e.preventDefault();

                    $(document).on('mouseup', function (e) {
                        setTimeout(function () {
                            var left = parseInt(editor.posX(e.pageX));
                            var bottom = parseInt(editor.posY(e.pageY));

                            $('#gridTooltip').html('<span>(' + parseInt(editor.pixelToMM(left)) + '; </span><span>' + parseInt(editor.pixelToMM($('#gridbox').height() - bottom)) + ') mm</span>');
                            $(document).unbind('mouseup');
                        }, 1000);
                    })

                    return false;
                }
            })
            .on('dragstart', function(e){
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }

                editor.unselected();
            })
            .on('dragmove', function (e) {
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }

                var element = SVG.get(e.target.id);
                if (parseInt(editor.activeLayerID) !== parseInt(element.data('layerid'))) {
                    e.preventDefault();
                }

                editor.displayDataV2();
            })
            .on('dragend', function (e) {
                if(editor.ctrlDown){
                    e.preventDefault();
                    e.stopPropagation();

                    return false;
                }

                editor.removeSelectRect();

                var svgObj = SVG.get(e.target.id),
                    jObj = $('#' + e.target.id),
                    svgGroup = SVG.get(e.target.id + '_group');


                    jObj.data("centerx", editor.fromRelative(svgGroup.rbox().cx + $("#gridbox").parent().scrollLeft()) );
                    jObj.data("centery", editor.fromRelative(svgGroup.rbox().cy + $("#gridbox").parent().scrollTop()) );

                editor.selectElement(svgObj);
                editor.saveElement();
            });
        obj.on('click', function (e) {
            var $this = SVG.get(e.target.id);

            if($this.parent().hasClass('ui-targeted')){
                var selected = editor.isSelectedElement();

                $.post('/stages/editor/connectionPopup/0', {objectfromID: selected.data('id'), objecttoID: $(e.target).data('id')}, function(resp){
                    popup(resp, 'Create connection').dialog();
                });
            } else {
                editor.selectElement(SVG.get(e.target.id))
            }
        });


        obj.on('mouseover', function (e) {
            var element = SVG.get(e.target.id);
            var selected = editor.isSelectedElement();

            if (editor.ctrlDown && selected !== false && element.data('id') != selected.data('id')) {
                SVG.select('.element').parent().removeClass('ui-targeted');
                SVG.select('.element').off('mouseout');

                element.parent().addClass('ui-targeted');
                editor.addSelectRect(element);
                element.on('mouseout', function(e){
                    element.parent().select('rect').members[0].remove();
                    element.off('mouseout').parent().removeClass('ui-targeted');
                });
            }
        });
    }
    ,
    load: function() {
        var params = {};

        $.post('/stages/editor', params, function(resp){
            elements = [];
            editor.activeLayerID = resp.activeLayerID;
            editor.baseLayerID = resp.baseLayerID;
            editor.connectionsLayerID = resp.connectionsLayerID;
            editor.accesoriesLayerID = resp.accesoriesLayerID;
            editor.connectionLayers = resp.connectionLayers;

            $('.element', '#gridbox').remove();

            editor.loadElements(resp);
            editor.loadConnections(resp.connections);

            actZoom = 1;

            if(typeof resp.xml !== 'undefined' && resp.xml !== null)
            {
                if(typeof resp.xml.guidelines !== 'undefined'){
                    editor.configureGuideLines(resp.xml.guidelines.guideline);
                }

                if(typeof resp.xml.act_zoom !== 'undefined'){
                    actZoom = resp.xml.act_zoom;
                }
            }

            zoomRatio = actZoom == 1 ? 1 : 1.25;

            scale();
        }, 'json');
    },
    loadElements: function(resp, move)
    {
        move = (typeof move == 'boolean' ? move : true )

        $.each( resp.elements, function(index, object)
        {
            var val = {};

            var element = editor.configureElement(object, move);
            var connectionSvg = SVG('gridsvg');

            connectionSvg.add(element.group);
            editor.bindEvents(element.image);

            val.element = element.image;
            elements.push(val);
        });
    },
    loadConnections: function(resp){
        $.each(resp, function( layerId, connections )
        {
            $.each(connections, function(objectconnectionID, objectConnection) {
                var lineElement = editor.configureConnection(objectConnection);
                var connectionSvg = SVG('gridsvg');

                connectionSvg.add(lineElement);
                editor.bindConnectionEvents(lineElement);
            });
        });
    },
    getJSONParams: function(obj){
        var jsonParams = {};
        jsonParams.id = obj.data('id');
        // jsonParams.width = obj.data('rotation') == 90 ? obj.data('height') : obj.data('width');
        jsonParams.width = obj.data('width');
        // jsonParams.height = obj.data('rotation') == 90 ? obj.data('width') : obj.data('height');
        jsonParams.height = obj.data('height');
        jsonParams.templateobjectid = obj.data('templateobjectid');
        jsonParams.templateobjectattachment = obj.data('templateobjectattachment');
        jsonParams.centerx = obj.data('centerx');
        jsonParams.centery = obj.data('centery');
        jsonParams.rotation = obj.data('rotation');
        jsonParams.objecttypename = obj.data('objecttype_name');
        jsonParams.objectfamilycode = obj.data('objectfamily_code');
        jsonParams.templateobjectname = obj.data('templateobjectname'),
        jsonParams.zindex = obj.data('z_index');
        jsonParams.objecttypeid = obj.data('objecttypeid');
        jsonParams.layerid = obj.data('layerid');

        return jsonParams;
    },

    configureElement: function(element, move)
    {
        move = (typeof move == 'boolean' ? move : true );
        editor.unselected();

        var elementGroup = SVG.get('element_' + element.id + '_group') !== null ? SVG.get('element_' + element.id + '_group') : SVG('gridsvg').group().attr({'id':'element_' + element.id + '_group'});
        var imageElement = SVG.get('element_' + element.id) !== null ? SVG.get('element_' + element.id) : elementGroup.image(imagePath + '/' + element.templateobjectid + '/' + element.templateobjectattachment, element.width, element.height);

        if(move){
            imageElement
                .move((element.centerx - element.width / 2), (element.centery - element.height / 2))
                .rotate(element.rotation)
                ;
        }

        imageElement.attr({
            'visibility':(element.layerid == editor.baseLayerID || element.layerid == editor.connectionsLayerID || element.layerid == editor.accesoriesLayerID ? 'visible' : 'hidden'),
            'class':'element',
            'id':'element_' + element.id,
        })
            .data({
                'objecttype_name':element.objecttypename,
                'objectfamily_code':element.objectfamilycode,
                'templateobjectname':element.templateobjectname,
                'width':element.width,
                'height':element.height,
                'z_index':element.zindex,
                'id':element.id,
                'rotation':element.rotation,
                'objecttypeid':element.objecttypeid,
                'templateobjectid':element.templateobjectid,
                'templateobjectattachment':element.templateobjectattachment,
                'layerid':element.layerid,
                'resize': element.resize,
                'centerx': element.centerx,
                'centery': element.centery,
            });

        // editor.selectElement(imageElement);
        return {group:elementGroup,image:imageElement};
    },
    configureConnection: function(objectConnection){
        // var lineElement = document.createElementNS("http://www.w3.org/2000/svg", 'line');
        var x1, x2, y1, y2;
        var from = SVG.get('element_' + objectConnection.from);
        var to = SVG.get('element_' + objectConnection.to);

        var fromLeft = (from.data('rotation') == 0 ? from.bbox().x : from.rbox().x / actZoom);
        var fromRight = (from.data('rotation') == 0 ? from.bbox().x2 : from.rbox().x2 / actZoom);
        var fromTop = (from.data('rotation') == 0 ? from.bbox().y2 : from.rbox().y2 / actZoom);
        var fromBottom = (from.data('rotation') == 0 ? from.bbox().y : from.rbox().y / actZoom);
        var fromCX = (from.data('rotation') == 0 ? from.bbox().cx : from.rbox().cx / actZoom);
        var fromCY = (from.data('rotation') == 0 ? from.bbox().cy : from.rbox().cy / actZoom);

        var toLeft = (to.data('rotation') == 0 ? to.bbox().x : to.rbox().x / actZoom);
        var toRight = (to.data('rotation') == 0 ? to.bbox().x2 : to.rbox().x2 / actZoom);
        var toTop = (to.data('rotation') == 0 ? to.bbox().y2 : to.rbox().y2 / actZoom);
        var toBottom = (to.data('rotation') == 0 ? to.bbox().y : to.rbox().y / actZoom);
        var toCX = (to.data('rotation') == 0 ? to.bbox().cx : to.rbox().cx / actZoom);
        var toCY = (to.data('rotation') == 0 ? to.bbox().cy : to.rbox().cy / actZoom);

        //A from középpontja a to szélső pontjain belülre esik és a from objektum a to objektum alatt vagy fölött helyezkedik el
        if(from.bbox().cx >= toLeft && from.bbox().cx <= toRight && (fromTop <= toBottom || fromBottom >= toTop)){
            x1 = fromCX;
            x2 = toCX;

            //A from a to objektum alatt helyezkedik el
            if(fromTop <= toBottom){
                y1 = fromTop;
                y2 = toBottom;
            } else {
                y1 = fromBottom;
                y2 = toTop;
            }
        }
        else {
            y1 = fromCY;
            y2 = toCY;

            if(parseInt(objectConnection.centerx1) < parseInt(objectConnection.centerx2)){   //x1 -> x2
                x1 = fromRight;
                x2 = toLeft;
            } else { //x2 <- x1
                x1 = fromLeft;
                x2 = toRight;
            }
        }

        var lineElement = SVG('gridsvg').line(x1,y1,x2,y2).attr({
            'stroke':objectConnection.connectiontype_color,
            'stroke-width':2,
            'marker-end':'url(#arrow_' + objectConnection.connectiontype_name + ')',
            'id':'connection_' + objectConnection.id,
            'marker-start':'url(#circle_' + objectConnection.connectiontype_name + ')',
            'class':'connection-arrow'
        }).data({
            'from':objectConnection.from,
            'to':objectConnection.to,
            'id':objectConnection.id,
            'connectiontype_color': objectConnection.connectiontype_color,
            'connectiontype_name': objectConnection.connectiontype_name,
        });

        return lineElement;
    },
    bindConnectionEvents: function(objectConnectionElement){
        objectConnectionElement
            .on('click', function(e){
                $.post('/stages/editor/connectionPopup/' + objectConnectionElement.data('id'), {}, function(resp){
                    popup(resp, 'Edit connection').dialog();
                });
            }).on('mouseover', function(e){
            e.target.setAttribute('stroke-width', 3);
        }).on('mouseout', function(e){
            e.target.setAttribute('stroke-width', 2);
        });
    },
    configureGuideLines: function (guidelines) {
        if(typeof guidelines == 'array') {
            $.each(guidelines, function () {
                if (this.type == 'h') {
                    editor.horizontalGuideLine({}, this);
                } else {
                    editor.verticalGuideLine({}, this);
                }
            })
        }else{
            if (guidelines.type == 'h') {
                editor.horizontalGuideLine({}, guidelines);
            } else {
                editor.verticalGuideLine({}, guidelines);
            }
        }
    },
    toggleLayerElements: function(layerID, layerCode, layerState){
        editor.activeLayerType(layerID, layerCode, layerState);

        $('.element[data-layerid="' + layerID + '"]').each(function(key, obj){
            var object = $(obj);

            //Azért tüntetem el a kapcsolatokat, ezzel a feltétellel, mert az objektum eltüntetése lassítva történik meg
            if($('#element_' + object.data('id') + '_group').css('display') != 'none'){    //látható még, de el fog tünni
                $('.connection-arrow[data-from="' + object.data('id') + '"], .connection-arrow[data-to="' + object.data('id') + '"]').each(function(index, obj){
                    $(obj).hide('slow');
                });
            } else {
                $('.connection-arrow[data-from="' + object.data('id') + '"], .connection-arrow[data-to="' + object.data('id') + '"]').each(function(index, obj){
                    $(obj).show('slow');
                });
            }


            $('#element_' + object.data('id') + '_group').toggle('slow')
        });
    },
    toggleElementListPanel: function(layerID){
        var elementListPanel = $('#layer_' + layerID + ' .elementListPanel');

        $(elementListPanel).toggle('slow', function(){
            $('.element[data-layerid="' + layerID + '"]').each(function(key, obj){
                $(obj).toggle('slow');
            });
        });
    },
    projectLoad: function(templateobjectID){
        $.post('/stages/editor/projectLoad/' + templateobjectID, {}, function(resp){
            location.reload();
        });
    },
    createPopup: function(){
        $.post('/stages/editor/createPopup', {}, function(resp){
            popup(resp, 'Create new zone template').dialog();
        });
    },
    loadPopup: function(){
        $.post('/stages/editor/loadPopup', {}, function(resp){
            popup(resp, 'Load zone template').dialog();
        });
    },
    loadPopupJson: function(page){
        var page = page || $('#page').val();

        $.post('/stages/editor/loadPopup/1', {'like': $('#like').val(), 'page': page}, function(resp){
            $('#templateobjectList tbody').html(resp.templateobjectList);
            $('#panel-footer').html(resp.pager);
            $('#page').val(resp.page);

            editor.loadPopupBindEvent();
        }, 'json');
    },
    loadPopupBindEvent: function(){
        $('#templateobjectList tbody tr').on('click', function(e){
            editor.loadTemplateDescription($(this).data('id'));
        }).on('dblclick', function(e){
            editor.loadTemplateDescription($(this).data('id'));
            editor.loadProject();
        });

        editor.loadTemplateDescription($($('#templateobjectList tbody tr')[0]).data('id'));
    },
    createProject: function(){
        var params = {templateobject_name: $('#templateobject_name').val(), objecttypeID: $('#objecttypeID').val(), templateobject_description: $('#templateobject_description').val(),locationID:$("#locationID option:selected").val(), stageID: $("#stageID option:selected").val()};

        $.post('/stages/editor/createProject', params, function(resp){
            editor.projectLoad(resp);
        })
    },
    logout: function(){
        $.post('/stages/editor/logout', {}, function(){
            location.reload();
        });
    },
    addLayerPopup: function(layertypeID){
        $.post('/stages/editor/addLayerPopup', {layertypeID: layertypeID}, function(resp){
            popup(resp, 'Add new layer').dialog();
        });
    },
    createLayer: function(){
        $.post('/stages/editor/createLayer', {layertypeID: $('#layertypeID').val(), layer_name: $('#layer_name').val()}, function(){
            location.reload();
        })
    },
    activeLayer: function(layerID){
        if(layerID > 0){
            $.post('/stages/editor/activeLayer/' + layerID, {}, function(){});
        }
    },
    loadTemplateDescription: function(templateobjectID){
        $('#templateobjectList tbody tr').removeClass('active');
        $('#templateobjectList tbody tr[data-id="' + templateobjectID + '"]').addClass('active');

        $.post('/stages/editor/loadTemplateDescription/' + templateobjectID, {}, function(resp){
            $('#targetDescription').html(resp);
        });
    },
    loadProject: function(){
        var templateobjectID = $('#templateobjectList tbody tr.active').data('id');
        editor.projectLoad(templateobjectID);
    },
    activeLayerType: function(layerID, layerCode, layerState){
        $.post('/stages/editor/activeLayerType', {layerID: layerID, layerCode: layerCode, layerState: layerState}, function(){});
    },
    removeLayer: function(layerID){
        popup('Are you sure you want to delete this layer: "' + $('#layer_' + layerID + ' .layer-name').html() + '" ?', 'Confirm: Delete layer').confirm(true, function(result){
            if(result){
                $.post('/stages/editor/removeLayer/' + layerID, {}, function(resp){
                    $('#layer_' + layerID).remove();
                    $('.element[data-layerid="' + layerID + '"]').remove();
                });
            }
        });
    },
    visibleLayer: function(layerID){
        if($('#layer_' + layerID).find('fa-eye').length > 0){
            return true;
        }

        return false;
    },
    connectionDelete: function(objectConnectionID){
        $.post('/stages/editor/connectionDelete/' + objectConnectionID, {}, function(){
            $('#connection_' + objectConnectionID).remove();
            closeLastPopup();
        });
    },
    connectionSave: function(objectConnectionID){
        var objectConnectionID = objectConnectionID || 0;

        var params = {
            connectiontypeID: $('#connectiontypeID').val(),
            objectfromID: $('#objectfromID').val(),
            objecttoID: $('#objecttoID').val(),
            porttypefromID: $('#porttypefromID').val(),
            porttypetoID: $('#porttypetoID').val(),
            layerID: $('#layerID').val(),
            objectconnection_port_out_no: $('#objectconnection_port_out_no').val(),
            objectconnection_port_in_no: $('#objectconnection_port_in_no').val(),
        };

        $.post('/stages/editor/connectionSave/' + objectConnectionID, params, function(resp){
            closeLastPopup();
            editor.loadConnections(resp);
        }, 'json').fail(function(resp) {
            utils.error(resp.responseJSON);
        });
    },
    horizontalGuideLine: function (e, l) {
        l = l || {};
        editor.guideLine(
            l.x || 0,
            l.y || ((e.originalEvent.pageY - $("#gridsvg").position().top) / actZoom),
            $('#gridsvg').width(),
            l.y || ((e.originalEvent.pageY - $("#gridsvg").position().top) / actZoom),
            {left:0},
            'horizontalGuideLine'
        );
    },
    verticalGuideLine: function (e, l) {
        l = l || {};
        editor.guideLine(
            l.x || ((e.originalEvent.pageX - $("#gridsvg").position().left) / actZoom),
            l.y || 0,
            l.x || ((e.originalEvent.pageX - $("#gridsvg").position().left) / actZoom),
            $('#gridsvg').height(),
            {top:0},
            'verticalGuideLine'
        );
    },
    guideLine:function (x1,y1,x2,y2,draggableOffset,className) {
        var group = SVG('gridsvg').group().addClass(className+'Group'),
            line = group.line(x1,y1,x2,y2),
            linePath = line.toPath().attr({
                'stroke':'#00ffff',
                'stroke-width':'1',
                'stroke-linejoin':"bevel"
            }).addClass(className);

        line.remove();
        linePath.draggable(true, {}, function(obj, e){
            return draggableOffset;
        }).on('dragend', function (e) {
            var params = {};
            params.guidelines = {};
            params.guidelines.guideline = [];
            $.each(SVG.select('.verticalGuideLine,.horizontalGuideLine').members, function (id, obj) {
                params.guidelines.guideline[id] = {x:obj.rbox().x,y:obj.rbox().y, type: obj.hasClass('verticalGuideLine')?'v':'h'};
            });
            $.post('/stages/editor/saveParent',params);
        });
        linePath.click(function(e){
            editor.displayData(this);
        });
    },
    closestPoint: function(pathNode, point) {
        if(pathNode !== null && typeof pathNode !== 'undefined' && typeof pathNode.length !== 'undefined') {
            var pathLength = pathNode.length(), precision = pathLength / pathNode._array.value.length * 0.125, best, bestLength, bestDistance = Infinity;

            for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
                if ((scanDistance = distance2(scan = pathNode.pointAt(scanLength))) < bestDistance) {
                    best = scan, bestLength = scanLength, bestDistance = scanDistance;
                }
            }
            precision *= 0.5;
            while (precision > 0.5) {
                var before, after, beforeLength, afterLength, beforeDistance, afterDistance;
                if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.pointAt(beforeLength))) < bestDistance) {
                    best = before, bestLength = beforeLength, bestDistance = beforeDistance;
                } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.pointAt(afterLength))) < bestDistance) {
                    best = after, bestLength = afterLength, bestDistance = afterDistance;
                } else {
                    precision *= 0.5;
                }
            }
            best = [
                best.x,
                best.y
            ];
            best.distance = Math.sqrt(bestDistance);
            return best;
        }else{
            return false;
        }
        function distance2(p) {
            var dx = p.x - point[0], dy = p.y - point[1];
            return dx * dx + dy * dy;
        }
    },



    saveElement: function()
    {
        var params = {};
        var element = $('#element_' + editor._selectedElementID);

        for(var i in element.data()){
            if(typeof(element.data(i)) != 'object' && typeof(element.data(i)) != 'boolean'){
                eval("params." + i + " = '" + element.data(i) + "'");
            }
        }

        if(params.id != 'undefined')
        {
            $('.connection-arrow[data-to="' + element.data('id') + '"], .connection-arrow[data-from="' + element.data('id') + '"]').each(function(index, obj){
                var connectionObject = $(obj);
                var from = $('#element_' + connectionObject.data('from'));
                var to = $('#element_' + connectionObject.data('to'));
                var connectionSvg = SVG('gridsvg');

                var modifyedConnectionElement = editor.configureConnection({
                    id: connectionObject.data('id'),
                    from: connectionObject.data('from'),
                    centerx1: from.data('centerx'),
                    centery1: from.data('centery'),
                    width1: from.data('width'),
                    height1: from.data('height'),
                    to: connectionObject.data('to'),
                    centerx2: to.data('centerx'),
                    centery2: to.data('centery'),
                    width2: to.data('width'),
                    height2: to.data('height'),
                    'connectiontype_color': connectionObject.data('connectiontype_color'),
                    'connectiontype_name': connectionObject.data('connectiontype_name'),
                });

                obj.remove();

                connectionSvg.add(modifyedConnectionElement);
                editor.bindConnectionEvents(modifyedConnectionElement);
            });
            console.debug(params);
            $.post('/stages/editor/modifyElement/' + params.id, params, function(resp){});

            // $.ajax({
            //     type: 'POST',
            //     url: '/stages/editor/modifyElement/' + params.id,
            //     data: params,
            //     // success: success,
            //     // dataType: dataType,
            //     async:false
            // });
        }
    },

    saveV2: function()
    {
        if(editor._selectedElementID !== null)
        {
            editor.removeSelectRect();

            var element = $('#element_' + editor._selectedElementID),
                selectedElementGroup = SVG.get('element_' + editor._selectedElementID + '_group'),
                oldDisplayDataParams = editor.displayDataParams();

            $('#displaydata input').each(function(index, obj)
            {
                var value = $(obj).val(),
                    trans = 0;

                if(obj.id == 'x' && value != oldDisplayDataParams.x){
                    trans = (value - oldDisplayDataParams.x) * editor.shiftValue();

                    if( (rotation = selectedElementGroup.transform().rotation) != 0){
                        selectedElementGroup.transform({rotation: 0});
                        selectedElementGroup.transform({x: trans, relative: true});
                        selectedElementGroup.transform({rotation: rotation});
                    } else {
                        selectedElementGroup.transform({x: trans, relative: true});
                    }

                    element.data('centerx', editor.fromRelative(selectedElementGroup.rbox().cx));
                }
                else if(obj.id == 'y' && value != oldDisplayDataParams.y){
                    trans = (oldDisplayDataParams.y - value) * editor.shiftValue();

                    if( (rotation = selectedElementGroup.transform().rotation) != 0){
                        selectedElementGroup.transform({rotation: 0});
                        selectedElementGroup.transform({y: trans, relative: true});
                        selectedElementGroup.transform({rotation: rotation});
                    } else {
                        selectedElementGroup.transform({y: trans, relative: true});
                    }

                    element.data('centery', editor.fromRelative(selectedElementGroup.rbox().cy));
                }
                else if(obj.id == 'width' && value != oldDisplayDataParams.width){
                    trans = oldDisplayDataParams.width / value;
                    selectedElementGroup.transform({scaleX: trans});
                    element.data('width', editor.fromRelative(selectedElementGroup.rbox().w));
                }
                else if(obj.id == 'height' && value != oldDisplayDataParams.height){
                    trans = oldDisplayDataParams.height / value;
                    selectedElementGroup.transform({scaleY: trans});
                    element.data('height', editor.fromRelative(selectedElementGroup.rbox().h));
                }
                else if(obj.id == 'rotation' && value != oldDisplayDataParams.rotation){
                    value = (value == '' ? 0 : value);

                    if(selectedElementGroup.transform().rotation != 0){
                        trans = value;
                    } else {
                        trans = value - oldDisplayDataParams.rotation;
                    }

                    selectedElementGroup.transform({rotation: trans});

                    element.data('rotation', value);
                    element.data('centerx', editor.fromRelative(selectedElementGroup.rbox().cx));
                    element.data('centery', editor.fromRelative(selectedElementGroup.rbox().cy));

                    editor.displayDataV2();
                }
            });

            editor.saveElement();
            editor.addSelectRectV2();
        } else {
            popup('Please select element!').alert();
        }
    },
};


